import React, { useState, useContext } from 'react';
import { Card, ListGroup, Badge, NavDropdown } from 'react-bootstrap';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useWidgetContext } from '../context/DragContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import Skeleton from 'react-loading-skeleton';
import SwitchAccount from '../common/SwitchAccount';

function NewsFeed() {
    const { userData, newsData, symbolData, newsDataLoading, sentimentScore } = useContext(AuthContext);
    const [selectedNews, setSelectedNews] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const { removeWidgetFromGrid } = useWidgetContext();
    const [switchAccount, setSwitchAccount] = useState(false);
    const location = useLocation(); 
    const navigate = useNavigate();
    const token = localStorage.getItem('accessToken');

    const handleOpenSwitchAccount = () => setSwitchAccount(true);
    const handleCloseSwitchAccount = () => setSwitchAccount(false);

    const handleToggle = (isOpen) => {
        setShowDropdown(isOpen);
    };

    const handleSvgClick = () => {
        setShowDropdown(!showDropdown);
    };

    const [open, setOpen] = useState(false);
    const handleClickOpen = (item, index) => {
        setSelectedNews({ ...item, newsIndex: index });
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedNews(null);
    };

    const newsItems = [
        {
            id: 1,
            sentiment: '1.0',
            sentimentColor: 'success',
            title: "Gold rebounds as market's focus turns to US inflation data",
            description: "Gold prices rebounded on Monday after the previous metal's biggest daily drop in three and a half years in the last session",
            source: "Reuters",
            time: "1 hour ago",
            posted_by: "By Harshit Verma",
            posted_date: "June 10, 2024 2:32 PM EDT",
            updated_on: "Updated 24 days ago"
        },
        {
            id: 2,
            sentiment: '-0.2',
            sentimentColor: 'danger',
            title: "Gold prices drop ahead of US Fed outcome",
            description: "Gold prices: The Multi Commodity Exchange (MCX) gold futures for August 2024 expiry opened lower at $71251 per 10 grams.",
            source: "CNBCTV18",
            time: "14 hours ago",
            posted_by: "By Harshit Verma",
            posted_date: "June 10, 2024 2:32 PM EDT",
            updated_on: "Updated 24 days ago"
        },
        {
            id: 3,
            sentiment: '0.5',
            sentimentColor: 'success',
            title: "Gold prices hit a record high. What's behind the surge?",
            description: "The price of gold has climbed 17% in 2024. ByMax Zahn. April 12, 2024, 10:41 AM. 3:43. Sales of gold bars surge at Costco. A report from Wells",
            source: "ABD News",
            time: "April 12, 2024",
            posted_by: "By Harshit Verma",
            posted_date: "June 10, 2024 2:32 PM EDT",
            updated_on: "Updated 24 days ago"
        }
    ];

    const isDemoPath = location.pathname === '/demo';

    const handleDemo = () => {
        if(token){
            navigate('/pricing-plans', { state: { email: userData.email, name : userData.name } });
        }
        else{
            navigate('/signup');
        }
    }

    const formatToLocalTime = (utcDate, formatType = 'full') => {
        const options = formatType === 'short' 
            ? { month: 'short', day: 'numeric' } // "Jun 10"
            : { 
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
                timeZoneName: 'short', // "June 10, 2024 2:32 PM EDT"
            };
    
        return new Date(utcDate).toLocaleString('en-US', options);
    };    

    return (
        <>
        <Card className={`main-card mt-3 ${isDemoPath ? 'blur-card' : ''}`}>
            {isDemoPath && (
                <div className="blur-overlay">
                <img
                    src={`${process.env.PUBLIC_URL}/images/lock-icon.svg`}
                    alt="Lock Icon"
                    style={{ height: '20px', width: '16px' }}
                    className="lock-icon"
                />
                {isDemoPath && <button className="subscribe-button" onClick={handleDemo}>Subscribe to access</button>}
                </div>
            )}
            <Card.Header className="pb-0">
                <div className="d-flex justify-content-between mt-1">
                    <h2 className="medium-heading mb-0">News</h2>
                    <div>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            onClick={handleSvgClick}
                            style={{ cursor: 'pointer' }}
                            >
                            <path d="M12 13.5C11.7033 13.5 11.4133 13.412 11.1666 13.2472C10.92 13.0824 10.7277 12.8481 10.6142 12.574C10.5006 12.2999 10.4709 11.9983 10.5288 11.7074C10.5867 11.4164 10.7296 11.1491 10.9393 10.9393C11.1491 10.7296 11.4164 10.5867 11.7074 10.5288C11.9983 10.4709 12.2999 10.5006 12.574 10.6142C12.8481 10.7277 13.0824 10.92 13.2472 11.1666C13.412 11.4133 13.5 11.7033 13.5 12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5Z" fill="white" />
                            <path d="M18.75 13.5C18.4533 13.5 18.1633 13.412 17.9166 13.2472C17.67 13.0824 17.4777 12.8481 17.3642 12.574C17.2506 12.2999 17.2209 11.9983 17.2788 11.7074C17.3367 11.4164 17.4796 11.1491 17.6893 10.9393C17.8991 10.7296 18.1664 10.5867 18.4574 10.5288C18.7483 10.4709 19.0499 10.5006 19.324 10.6142C19.5981 10.7277 19.8324 10.92 19.9972 11.1666C20.162 11.4133 20.25 11.7033 20.25 12C20.25 12.3978 20.092 12.7794 19.8107 13.0607C19.5294 13.342 19.1478 13.5 18.75 13.5Z" fill="white" />
                            <path d="M5.25 13.5C4.95333 13.5 4.66332 13.412 4.41665 13.2472C4.16997 13.0824 3.97771 12.8481 3.86418 12.574C3.75065 12.2999 3.72094 11.9983 3.77882 11.7074C3.8367 11.4164 3.97956 11.1491 4.18934 10.9393C4.39912 10.7296 4.66639 10.5867 4.95737 10.5288C5.24834 10.4709 5.54994 10.5006 5.82403 10.6142C6.09812 10.7277 6.33238 10.92 6.49721 11.1666C6.66203 11.4133 6.75 11.7033 6.75 12C6.75 12.3978 6.59197 12.7794 6.31066 13.0607C6.02936 13.342 5.64783 13.5 5.25 13.5Z" fill="white" />
                        </svg>
                        <NavDropdown
                            show={showDropdown}
                            onToggle={handleToggle}
                            title=""
                            id="nav-dropdown"
                            align="end"
                            className="d-inline custom-nav-dropdown"
                            style={{ display: showDropdown ? 'block' : 'none' }}
                            >
                            <NavDropdown.Item className="dropdown-option" onClick={() => removeWidgetFromGrid('news')}>Close Window</NavDropdown.Item>
                        </NavDropdown>
                    </div>
                </div>
            </Card.Header>
            <Card.Body className="pt-0 pr-2 pb-0 scrollbar-custom w-t-div">
                {isDemoPath ? (
                    <ListGroup variant="flush" className="news-list  pr-1">
                        {newsItems.map(item => (
                            <ListGroup.Item key={item.id} className="news-item">
                                <div className="d-flex justify-content-between align-items-start">
                                    <Badge bg={item.sentimentColor} className="sentiment-badge">{item.sentiment}</Badge>
                                    <div className="ms-3 me-auto news-data">
                                        <div className="fw-bold news-title">{item.title}</div>
                                        <div className="news-description mt-1 mb-1">{item.description}</div>

                                        <div className="news-source text-end">
                                            <small>{item.source} </small>
                                            <small>|</small>
                                            <small> {item.time}</small>
                                        </div>
                                    </div>
                                </div>

                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                ) :newsDataLoading ? (
                    <div>
                        <Skeleton
                            count={3} width="98%"
                            style={{ margin: '4px 2px', borderRadius: '3px' }}
                            baseColor="rgba(137, 136, 137, 0.3)"
                            highlightColor="rgba(176, 176, 176, 0.3)"
                        />
                        {/* <hr className="mt-2 mb-2" />
                        <Skeleton
                            count={3} width="98%"
                            style={{ margin: '4px 2px', borderRadius: '3px' }}
                            baseColor="rgba(137, 136, 137, 0.3)"
                            highlightColor="rgba(176, 176, 176, 0.3)"
                        /> */}
                    </div>
                ) : Array.isArray(newsData) && newsData.length > 0 ? (
                    <ListGroup variant="flush" className="news-list pr-1">
                        {newsData.map((item, newsIndex) => {
                            // Find the insight that matches the symbolData
                            const matchingInsight = item.insights?.find(insight => insight.ticker === symbolData);

                            return (
                                <ListGroup.Item key={item.id} className="news-item">
                                    <div className="d-flex justify-content-between align-items-start">
                                        {matchingInsight && sentimentScore?.[newsIndex] !== undefined && (
                                            <Badge
                                                bg={sentimentScore[newsIndex] >= 0 ? "success" : "danger"}
                                                className="sentiment-badge"
                                            >
                                                {sentimentScore[newsIndex].toFixed(1)}
                                            </Badge>
                                        )}
                                        <div className="ms-3 me-auto news-data">
                                            <div className="fw-bold news-title" onClick={() => handleClickOpen(item, newsIndex)}>
                                                {item.title}
                                            </div>
                                            <div className="news-description mt-1 mb-1">{item.description}</div>
                                            <div className="news-source text-end">
                                                <small>{item.publisher.name} </small>
                                                <small>|</small>
                                                <small> {formatToLocalTime(item.published_utc)}</small>
                                            </div>
                                        </div>
                                    </div>
                                </ListGroup.Item>
                            );
                        })}
                    </ListGroup>
                ) : (
                    <p>No news available</p>
                )}

                <Dialog
                    maxWidth="sm"
                    open={open}
                    onClose={handleClose}
                >
                    <DialogTitle>
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="mb-0 dialog-p">News</p>
                            <div>
                                <img style={{ float: 'none' }} src={`${process.env.PUBLIC_URL}/images/close.png`} alt="close" className="close-icon" role="button" onClick={handleClose} />
                            </div>
                        </div>
                        {selectedNews ? selectedNews.title : 'News Details'}
                    </DialogTitle>
                    <DialogContent className="scrollbar-custom">
                        <DialogContentText>
                            <div className="d-flex align-items-center mb-3">
                                {selectedNews && selectedNews.newsIndex !== undefined && sentimentScore?.[selectedNews.newsIndex] !== undefined && (
                                    <Badge 
                                        bg={sentimentScore[selectedNews.newsIndex] >= 0 ? "success" : "danger"} 
                                        className="dialog-badges"
                                    >
                                        {sentimentScore[selectedNews.newsIndex].toFixed(1)}
                                    </Badge>
                                )}
                                <div className="news-source-dialog ms-3">
                                    <small>{selectedNews ? selectedNews.publisher.name : 'NA'} </small>
                                    <small>|</small>
                                    <small> By {selectedNews ? selectedNews.author : 'NA'} </small>
                                    <small>|</small>
                                    <small> {selectedNews ? formatToLocalTime(selectedNews.published_utc) : 'NA'}</small>
                                    <small style={{display : selectedNews && selectedNews.updated_on ? 'block' : 'none'}}>,</small>
                                    <small> {selectedNews && selectedNews.updated_on ? selectedNews.updated_on : ''}</small>
                                </div>
                            </div>
                            
                            <span>
                                {selectedNews ? formatToLocalTime(selectedNews.published_utc, 'short'): ''} 
                                ({selectedNews ? selectedNews.publisher.name: ''}) - 
                                {selectedNews ? selectedNews.description: ''}
                            </span><br></br>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </Card.Body>
        </Card>
        
        <SwitchAccount open={switchAccount} onClose={handleCloseSwitchAccount}/>
        </>
    );
}

export default NewsFeed;
